import React, {Component} from "react";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import {withStyles} from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Styles from "../../styles/Styles";
import clsx from "clsx";
import {inject, observer} from "mobx-react";
import Avatar from "@material-ui/core/Avatar";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {withRouter} from "react-router-dom";

@inject('LayoutStore', 'AuthStore', 'AccountStore', 'LanguageStore')
@observer
class Navbar extends Component {
    componentDidMount() {
        this.props.AccountStore.getAccount();
    }

    state={
        anchorEl:null
    }
    handleClick(event){
        this.setState({anchorEl:event.currentTarget});
    }
    handleClose(){
        this.setState({anchorEl:null});
    }
    handleLogout() {
        console.log("logout");
        this.props.AuthStore.removeToken();
    }
    render() {
        const {classes} = this.props;
        return (
            <>
                <CssBaseline/>
                <AppBar position="absolute"
                        className={clsx(classes.appBar, !this.props.LayoutStore.drawer && classes.appBarShift)}>
                    <Toolbar className={classes.toolbar}>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => {
                                this.props.LayoutStore.toggleDrawer()
                            }}
                            className={clsx(classes.menuButton, !this.props.LayoutStore.drawer && classes.menuButtonHidden)}
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                            Dashboard
                        </Typography>
                        <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                            {/*{(brand)?(brand.account.account_title +'/'+brand.account.brand.brand_name):(null)}*/}
                        </Typography>
                        {/*<Tooltip title={(this.props.AuthStore.activeUser.name)?(this.props.AuthStore.activeUser.name):("")}>*/}
                        <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={(event)=>{this.handleClick(event)}} color="inherit">
                            <Avatar alt={this.props.AuthStore.activeUser.name} className={classes.orange} />
                        </IconButton>
                        {this.props.AuthStore.activeUser.name}/{this.props.AccountStore.brand.brand_name}
                        <Menu
                                id="simple-menu"
                                anchorEl={this.state.anchorEl}
                                keepMounted
                                open={Boolean(this.state.anchorEl)}
                                onClose={()=>{this.handleClose()}}
                            >
                                <MenuItem onClick={()=>{this.props.history.push({pathname:"/account"}); this.handleClose()}}>{this.props.LanguageStore.language.PROFILE}</MenuItem>
                                <MenuItem onClick={()=>{this.handleClose()}}>{this.props.LanguageStore.language.MY_ACCOUNT}</MenuItem>
                                <MenuItem onClick={()=>{this.handleLogout(); this.handleClose()}}>{this.props.LanguageStore.language.LOGOUT}</MenuItem>
                            </Menu>
                        {/*</Tooltip>*/}
                    </Toolbar>
                </AppBar>
            </>);
    }
}

const useStyles = theme => (Styles(theme));

export default withRouter(withStyles(useStyles, {withTheme: true})(Navbar));
